// extracted by mini-css-extract-plugin
module.exports = {"container":"index-module__container___2F-Ge"};